import PropTypes from "prop-types";


const Link = ({href, text, target, className, onClick}) => {
  let defaultColorClass = '';
  if(!className || !className.match(/text\-[a-zA-Z]/)) {
    defaultColorClass = 'text-uhblue';
  }
  return (
    <a 
      href={href}
      target={target}
      className={`${defaultColorClass} ${className}`}
      onClick={e=>onClick(e)}
    > 
      {text} 
    </a>
  );
}
Link.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}
export default Link;